// extracted by mini-css-extract-plugin
module.exports = {"TooltipContent":"TooltipContent__26-YO","TooltipContent__hdr":"TooltipContent__hdr__2TDpO","TooltipContent__ftr":"TooltipContent__ftr__2rtfM"};